export const environment = {
  production: false,
  baseURL: 'http://localhost:3000/api',

  projectName: 'genai-institute',

  version: '0.0.4',
};
